// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".action-comment[data-v-c4d311de]{margin-bottom:15px}.action-comment .metadata[data-v-c4d311de]{font-style:italic}.action-comment .metadata .user[data-v-c4d311de]{font-weight:700}.action-comment .comment-delete[data-v-c4d311de]{color:#ee335f;float:right;padding:5px;font-size:.9em;text-decoration:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
